// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-inline {
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/expedientes-detalle-ver-documentos/tabla-prestador/tabla-prestador.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ","sourcesContent":[".form-inline {\n    gap: 1rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
